import React, { Component } from 'react'
import { Task, StipulationResponse } from '../types'

export interface Props {
  task: Task
}

export default class Text extends Component<Props> {
  render() {
    const {
      task: { verifiables: verifiables },
    } = this.props

    const { response } = verifiables[0] as StipulationResponse

    return (
      <div>
        <div className="task-registration__col2">
          <div className="task-registration__info-header">
            <div className="task-registration__info-header__row">
              Response:{' '}
            </div>
          </div>
          <div className="task-registration__info-block">
            <div className="task-registration__info-block__row">{response}</div>
          </div>
        </div>
      </div>
    )
  }
}
